import React, { Component } from 'react';
import HorizontalRule from 'components/HorizontalRule';
import { optionsForEnum, simpleOptionsForEnum, multiSelectOptionsForEnum, sportsFilter } from 'helpers/enums';
import { trackMixpanelPageView } from 'helpers/post';
import { getSettingName, getSettingDetailsName } from 'helpers/enums';
import { connect } from 'react-redux';
import classNames from 'classnames';
import CustomCheckBox from 'components/V2/CustomInputs/CustomCheckBox';
import CustomRadioCheckBox from 'components/V2/CustomInputs/CustomRadioCheckBox';

export class EventProfile extends Component<Props> {
  componentDidMount() {
    if (!this.props.editMode) trackMixpanelPageView('create-event/profile', this.props.user);
  }

  onMultiSelectChangeAgeBracketsCheckbox = (value) => {
    const ageBracketIds = this.props.profile.ageBracketIds?.filter((id) => id !== '') || [];
    const updated = ageBracketIds.includes(String(value)) ? ageBracketIds.filter((v) => v !== String(value)) : [...ageBracketIds, String(value)];
    this.props.onChangeProfile('ageBracketIds', updated);
  };

  onFieldChange = (name: string) => (ev: SyntheticInputEvent<HTMLInputElement>) => {
    this.props.onChangeProfile(name, ev.target.value);
  };

  setLocations = (value) => {
    this.props.onDetailsChange('locationsNo', Math.min(value, 50));
  };

  addLocation = (num) => () => {
    const newLocations = Number(this.props.details.locationsNo || 0) + num;
    this.setLocations(newLocations < 1 ? 1 : newLocations);
  };

  getProfileTitle = () => {
    const { profile } = this.props;
    const setting = getSettingName(profile.eventSettingId);
    const settingDetail = getSettingDetailsName(profile.settingDetailId);

    if (setting !== 'Sports') return 'Job Name';

    return `${settingDetail} Name`;
  };

  render() {
    const { profile, enums, details } = this.props;
    const sportOptions = optionsForEnum(sportsFilter(enums.sports));
    const genderOptions = simpleOptionsForEnum(enums.genders);
    const ageBracketOptions = multiSelectOptionsForEnum(enums.ageBrackets);
    const settingName = getSettingName(profile.eventSettingId);

    const title = `${profile.title ?? ''}`;
    const sportId = `${profile.sportId ?? ''}`;
    const genderId = `${profile.genderId ?? ''}`;
    const ageBracketIds = profile.ageBracketIds?.filter((id) => id !== '') || [];

    return (
      <div className="eventProfile">
        <form
          id="profileForm"
          noValidate
          ref="form"
          className={classNames('', {
            'was-validated': profile.wasValidated,
          })}
        >
          <div className="row">
            <div className="form-group col-sm-12">
              <label htmlFor="title" className="section-label">{this.getProfileTitle()}</label>
              <input
                className="form-control italic-placeholder nimbus-regular-font"
                type="text"
                name="title"
                value={title}
                onChange={this.onFieldChange('title')}
                required
                maxLength="255"
                placeholder="Ex: Soccer Showcase, Basketball Game, etc."
              />
              <div className="invalid-feedback nimbus-regular-font">
                {this.getProfileTitle()} is required
              </div>
            </div>
          </div>
          <HorizontalRule dashed />
          <div className="row">
            {['School', 'Sports'].includes(settingName) && (
              <div className="form-group col-md-12">
                <label htmlFor="sport" className="section-label">Sport</label>
                <select
                  className="form-control custom-select nimbus-regular-font"
                  name="sport"
                  value={sportId}
                  onChange={this.onFieldChange('sportId')}
                  required
                >
                  {sportOptions}
                </select>
                <div className="invalid-feedback nimbus-regular-font">Sport is required</div>
              </div>
            )}
          </div>
          <div className="row">
            {['School', 'Sports'].includes(settingName) && (
              <div className="form-group col-md-12">
                <label htmlFor="ageBracket" className="section-label">Age Groups</label>
                <div className={classNames(
                  "age-checkbox-group",
                  {
                    'is-invalid': !ageBracketIds.length && profile.wasValidated,
                  })}
                >
                  {ageBracketOptions.map((option) => (
                    <CustomCheckBox
                      key={option.value}
                      id={`age-${option.value}`}
                      name="ageBracket"
                      checked={ageBracketIds.includes(String(option.value))}
                      onClick={() => this.onMultiSelectChangeAgeBracketsCheckbox(option.value)}
                      required={!ageBracketIds.length && profile.wasValidated}
                    >
                      {option.label}
                    </CustomCheckBox>
                  ))}
                </div>
                <div className="invalid-feedback nimbus-regular-font">Age is required</div>
              </div>
            )}
          </div>
          <div className="row">
            {['School', 'Sports'].includes(settingName) && (
              <div className="form-group col-md-6">
                <label htmlFor="gender" className="section-label">Gender</label>
                <div className={classNames("gender-radio-group",
                  {
                    'is-invalid': profile.wasValidated && genderId === '',
                  })}
                >
                  {genderOptions.map((option) => (
                    <CustomRadioCheckBox
                      key={option.value}
                      id={`gender-${option.value}`}
                      name="gender"
                      value={option.value}
                      checked={genderId !== '' && Number(genderId) === Number(option.value)}
                      onChange={this.onFieldChange('genderId')}
                      required={profile.wasValidated && genderId === ''}
                    >
                      {option.label}
                    </CustomRadioCheckBox>
                  ))}
                </div>
                <div className="invalid-feedback nimbus-regular-font">Gender is required</div>
              </div>
            )}
          </div>
          <div className="row">
            <div className="col-sm-12">
              <label className="section-label">How many locations are there?</label>
              <div className="input-group col-sm-4 p-0">
                <div className="input-group-append">
                  <span
                    type="button"
                    onClick={this.addLocation(-1)}
                    className="input-group-text remove-border-r"
                  >
                    <i className="fas fa-minus minus"></i>
                  </span>
                </div>
                <input
                  type="number"
                  name="locationsNo"
                  value={details.locationsNo}
                  onChange={(e) => this.setLocations(e.target.value)}
                  className={`form-control text-center pl-4 gotham-regular-font`}
                  placeholder="1"
                  min={1}
                  required
                />
                <div className="input-group-append">
                  <span type="button" onClick={this.addLocation(1)} className="input-group-text">
                    <i className="fas fa-plus plus"></i>
                  </span>
                </div>
                <div className="invalid-feedback nimbus-regular-font">
                  Number of locations is required
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  enums: state.enums,
  details: state.post.details,
  profile: state.post.profile,
  user: state.session.currentUser,
});

export default connect(mapStateToProps)(EventProfile);
